import React, { useState } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import HistoryIcon from '@mui/icons-material/History';
import TodayCheckinsView from './TodayCheckinsView';
import CheckinHistoryMatrix from './CheckinHistoryMatrix';

// สไตล์ pill segmented control เดียวกับ MAIN_TABS ใน OpportunityList.js (gradient ต่อแท็บแทนขีด
// เส้นใต้แบบ MUI Tabs เดิม) — ย่อขนาดลงมาใช้สลับมุมมองย่อยในแท็บนี้โดยเฉพาะ
const VIEW_TABS = [
  {
    value: 'today',
    label: 'วันนี้',
    icon: EventAvailableOutlinedIcon,
    gradient: 'linear-gradient(135deg, #06b6d4 0%, #3b82f6 100%)',
    caption: 'พนักงานที่เช็คอินวันนี้ จัดกลุ่มตามคน',
  },
  {
    value: 'history',
    label: 'ประวัติ',
    icon: HistoryIcon,
    gradient: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
    caption: 'ตารางเช็คอินย้อนหลังรายเดือน แยกตามโปรเจกต์และวันที่',
  },
];

// แท็บ "ภาพรวมการทำงาน" — สลับ 2 มุมมอง: "วันนี้" (การ์ดจัดกลุ่มตามพนักงาน กรองเฉพาะคนที่
// เช็คอินวันนี้) กับ "ประวัติ" (ตาราง matrix โปรเจกต์×วันที่) — คนละ component คนละไฟล์ ที่นี่แค่
// คุมการสลับมุมมอง
export function WorkOverviewTab({ employeeById, ownerNameById }) {
  const [view, setView] = useState('today');
  const active = VIEW_TABS.find((t) => t.value === view);

  return (
    <Box>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        justifyContent="space-between"
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        spacing={1}
        sx={{ px: 2, pt: 2, pb: 1.5 }}
      >
        <Stack
          direction="row"
          spacing={0.5}
          sx={{
            p: 0.5,
            borderRadius: '14px',
            border: '1px solid',
            borderColor: 'divider',
            bgcolor: 'action.hover',
          }}
        >
          {VIEW_TABS.map((t) => {
            const selected = view === t.value;
            const Icon = t.icon;
            return (
              <Box
                key={t.value}
                onClick={() => setView(t.value)}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.75,
                  px: 1.5,
                  py: 0.65,
                  borderRadius: '10px',
                  cursor: 'pointer',
                  userSelect: 'none',
                  whiteSpace: 'nowrap',
                  transition: 'transform 0.2s ease, background-color 0.2s ease, box-shadow 0.25s ease',
                  transform: selected ? 'translateY(-1px)' : 'none',
                  background: selected ? t.gradient : 'transparent',
                  boxShadow: selected ? '0 6px 16px -4px rgba(0,0,0,0.35)' : 'none',
                  '&:hover': {
                    background: selected ? t.gradient : (theme) => (theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(15,23,42,0.05)'),
                  },
                }}
              >
                <Icon sx={{ fontSize: 16, color: selected ? '#fff' : 'text.secondary' }} />
                <Typography sx={{ fontSize: '0.78rem', fontWeight: selected ? 700 : 500, color: selected ? '#fff' : 'text.secondary' }}>
                  {t.label}
                </Typography>
              </Box>
            );
          })}
        </Stack>
        <Typography variant="caption" color="text.secondary">{active.caption}</Typography>
      </Stack>

      {view === 'today'
        ? <TodayCheckinsView employeeById={employeeById} />
        : <CheckinHistoryMatrix ownerNameById={ownerNameById} />}
    </Box>
  );
}

export default WorkOverviewTab;
